module.exports = __webpack_public_path__ + "static/media/toggle-off.7a725eeb.svg";